import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getNationalities } from "../../slices/codeBookSlice";

export const useGetNationalities = () => {
  const nationalities = useSelector(
    (state: RootState) => state.codeBook.nationalities
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNationalities());
  }, [dispatch]);

  return nationalities;
};
